import React from 'react';
import WhatsApp from "../../../components/whatsApp";

const PhoneRender = (params) => {
    const {value} = params;

    const preparePhone = (number) => {
        if (!number) return '';

        if (number.length === 10 || number.length === 11) return number?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3")

        return number;

    }

    const preparedPhone = preparePhone(value)

    return (
        <>
            <div className={"flex justify-between"}>
                <span >{preparedPhone}</span>
                {
                    value ? <WhatsApp number={preparedPhone} className={"whatsAppRow"}/> : ""
                }
            </div>
        </>
    );
};

export default PhoneRender;